// Dependency-free WebAuthn helpers (IMP-045), split out of lib/webauthn.ts
// (IMP-062). <StepUpRoot /> is mounted on every page and needs these two at
// render time; importing them from lib/webauthn.ts dragged the passkey library
// and the Cloud Functions SDK into the start-up bundle. lib/webauthn.ts
// re-exports both, so existing imports keep working. (./dateFormat is light:
// it pulls only the date-text styles from @onlogic/shared.)

import { formatDayMonth } from './dateFormat';

/** True when this browser supports WebAuthn at all. */
export function isWebauthnSupported(): boolean {
  return typeof window !== 'undefined' && !!window.PublicKeyCredential;
}

/** A reasonable default device label, e.g. "Chrome on macOS · Jun 21". */
export function defaultDeviceName(): string {
  const ua = navigator.userAgent;
  const os = /Mac/.test(ua) ? 'macOS' : /Windows/.test(ua) ? 'Windows' : /Android/.test(ua) ? 'Android' : /iPhone|iPad/.test(ua) ? 'iOS' : 'this device';
  // Saved as the passkey's name, so it keeps the enrolling viewer's notation.
  return `${os} · ${formatDayMonth(new Date())}`;
}
